import React from 'react';
import { CheckCircle2Icon, LockIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
import { GoldPlaque } from '../ui/GoldPlaque';
import { CtaButton } from '../ui/CtaButton';
import { HeroMockup } from '../product/HeroMockup';
import { heroInclusions, heroTrust } from '../../data/site';
const trustIcons = {
  lock: LockIcon,
  mail: MailIcon,
  shield: ShieldCheckIcon
};
export function Hero() {
  return <section id="hero" aria-labelledby="hero-title" className="sport-hero relative overflow-hidden border-t-4 border-gold bg-mint text-ink" data-id="element-138" data-mp="374xpswvsamyo">
      <div className="relative z-10 mx-auto grid max-w-page items-center gap-10 px-5 pb-16 pt-6 sm:pt-14 lg:grid-cols-[1.02fr_0.98fr] lg:px-8 lg:pb-24 lg:pt-16" data-id="element-139" data-mp="3c76mo4bs2962">
        <div className="text-center lg:text-left" data-id="element-140" data-mp="3l4qphhpagdis">
          <GoldPlaque data-id="element-141" data-mp="1mq5iky7mn2hs">Your next flag football unit, sorted</GoldPlaque>
          <h1 id="hero-title" className="mt-6 font-display text-[36px] font-bold uppercase leading-[0.98] min-[400px]:text-[40px] sm:text-[56px] lg:text-[68px]" data-id="element-142" data-mp="1mryryl9mk0th">
            Flag football for the whole school year. <span className="text-gold-dark" data-id="element-143" data-mp="1y85c8kit2xu5">Already planned.</span>
          </h1>

          {/* First screen on mobile: title → mockup → button to the offer */}
          <div className="mt-5 lg:hidden" data-id="element-144" data-mp="1t923oq3ma9hf">
            <HeroMockup data-id="element-145" data-mp="1oa7ody4uz322" />
          </div>

          <div className="mt-6 lg:mt-8" data-id="element-146" data-mp="1ob8zu3psdrkb">
            <CtaButton target="offer" className="w-full sm:w-auto" data-id="element-147" data-mp="2lxg1p5uph5sz">
              See the complete kit
            </CtaButton>
          </div>

          <p className="mx-auto mt-7 max-w-xl text-base leading-relaxed text-body sm:text-lg lg:mx-0 lg:mt-7" data-id="element-148" data-mp="2gzodalt9s1tj">
            <strong className="font-bold text-ink" data-id="element-149" data-mp="2bxp77465aqsw">Your school year of flag football, solved</strong> — teach one class a month, or run them back to back as a full unit. Non-contact flag football for ages 10–14, with clear diagrams, timings and instructions for every class.
          </p>

          <ul aria-label="What you get" className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2.5 lg:justify-start" data-id="element-150" data-mp="vk8v1qjmsjrl">
            {heroInclusions.map(item => <li key={item} className="flex items-center gap-1.5 text-base font-bold" data-id="element-151" data-mp="3nt2nwxei1gui">
                <CheckCircle2Icon aria-hidden="true" className="h-[18px] w-[18px] text-gold-dark" data-id="element-152" data-mp="39t1lvemi03dg" />
                {item}
              </li>)}
          </ul>

          <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-153" data-mp="3etz23lny6ncb">
            {heroTrust.map(item => {
            const Icon = trustIcons[item.icon];
            return <li key={item.label} className="flex items-center gap-1.5 text-sm text-body" data-id="element-154" data-mp="34vje3rk7vu71">
                  <Icon aria-hidden="true" className="h-4 w-4 text-gold-dark" data-id="element-155" data-mp="2r0gvq4y6ocdc" />
                  {item.label}
                </li>;
          })}
          </ul>
          <p className="mt-5 text-sm text-body" data-id="element-156" data-mp="2h4nkqq044qxo">Pre-release preview · Main volume in production and awaiting PE-teacher review.</p>
        </div>

        <div className="hidden lg:block" data-id="element-157" data-mp="22h5e3m2zpm8m">
          <HeroMockup data-id="element-158" data-mp="22i6um62rz0xq" />
        </div>
      </div>
    </section>;
}